<template>
  <div class="customer-info main" :class="{ activeIndex1: activeIndex == 2 }">
    <van-sticky>
      <ul class="tab-list">
        <li class="visitor" :class="{ active: activeIndex == 1 }" @click="tabClick(1)">
          <span>访客</span>
        </li>
        <li :class="{ active: activeIndex == 2 }" @click="tabClick(2)">
          <span>客户</span>
        </li>
      </ul>
    </van-sticky>
    <div v-show="activeIndex == 1">
      <visitor ref="visitorRef" />
    </div>
    <div v-show="activeIndex == 2">
      <customerInfo ref="customerInfoRef" />
    </div>
  </div>
</template>
<script>
import { pageRes } from '@/api/mixins';
import visitor from './components/visitor';
import customerInfo from './components/customerInfo';
export default {
  mixins: [pageRes],
  components: {
    visitor,
    customerInfo
  },
  data() {
    return {
      activeIndex: 1,
      visitorCount: '',
      custCount: '',
      showSearch: true,
      searchName: ''
    };
  },
  created() {
    let type = this.$route.query.type;
    if (sessionStorage.getItem('okbaocustomerIdx')) {
      type = sessionStorage.getItem('okbaocustomerIdx');
      sessionStorage.removeItem('okbaocustomerIdx');
    }
    this.tabClick(type || 1);
    this.$weixin.hideMenu();
    this.$app.hideRightIcon();
  },
  methods: {
    tabClick(i) {
      this.activeIndex = i;
      if (i == 1) {
        this.$nextTick(() => {
          this.$refs.visitorRef.search();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.customerInfoRef.search();
        });
      }
    },
    getOtherCount() {
      this.$http({
        url: '/app/visitor/queryVisitorCountAndCustCount',
        type: 'PUT'
      }).then(resData => {
        this.custCount = resData.data.custCount;
        this.visitorCount = resData.data.visitorCount;
      });
    },
    search(e) {
      this.searchName = e.target.value;
      this.getListHttp();
    },
    setListParams(params) {
      if (this.activeIndex == 2) {
        params.policyerName = this.searchName;
      }
    },
    listCallback(data) {
      if (this.activeIndex == 2 && this.searchName == '' && this.list.length == 0) {
        this.showSearch = false;
      }
    },
    gocustomerInfo: function (item) {
      const url = location.origin + '/apps/customerInfo';
      const params = {
        level: this.$route.query.level,
        policyerName: item.policyerName,
        policyerMobile2: item.policyerMobile2,
        policyerMobile1: item.policyerMobile1,
        policyerSex: item.policyerSex,
        totalFee: item.totalFee,
        totalPolicyNum: item.totalPolicyNum
      };
      this.$app.openWeb(url, params);
    },
    goPorductDetail: function (item) {
      let url = location.origin + '/apps/customer/porduct';
      this.$app.openWeb(url, {
        typeId: item.typeId,
        type: item.type
      });
    }
  }
};
</script>
<style>
html,
body {
  background-color: whitesmoke;
}
</style>
<style lang='scss' scoped>
@import '~@/sass/native';
@import './customer';
</style>
